import { LegalPage } from "@/components/LegalPage";

const sections = [
  {
    heading: "Who we are",
    paragraphs: [
      "HRKAPITAL is registered with the Association of Mutual Funds in India (AMFI) as a Mutual Fund Distributor (MFD) and SIF Distributor under ARN Code – 369251. The firm is not a SEBI Registered Investment Advisor (RIA) and does not provide investment advisory services under the SEBI (Investment Advisers) Regulations, 2013.",
      "HRKAPITAL facilitates access to financial products — including mutual funds, PMS, AIFs, fixed income products, broking and lending services — through distribution and referral arrangements with respective institutions.",
    ],
  },
  {
    heading: "Information, not advice",
    paragraphs: [
      "Everything on this website — articles, illustrations and planning tools — is provided for general informational and educational purposes only. Nothing here constitutes investment advice, a recommendation, or an offer or solicitation to buy or sell any financial product.",
    ],
  },
  {
    heading: "Calculators & illustrations",
    paragraphs: [
      "The planning tools on this site use assumed rates of return and inflation chosen by you or suggested as defaults. Their outputs are illustrations, not forecasts, and actual outcomes will differ. Mutual fund investments are subject to market risks; read all scheme related documents carefully before investing.",
    ],
  },
  {
    heading: "Third-party products & partners",
    paragraphs: [
      "Certain services described on this website (such as stock broking, loans, PMS or AIF) are provided by independent third-party institutions under their own terms, eligibility criteria and documentation. HRKAPITAL may receive distribution commissions or referral fees from such providers, as described in our Key Terms & Disclosure.",
    ],
  },
  {
    heading: "Intellectual property",
    paragraphs: [
      "The HRKAPITAL name, logo, illustrations, articles and design of this website are the property of HRKAPITAL. You may not reproduce or reuse them without written permission.",
    ],
  },
  {
    heading: "Limitation of liability",
    paragraphs: [
      "HRKAPITAL is not liable for investment outcomes, market movements, or decisions made based on the contents of this website. While we work to keep the site accurate and available, we do not warrant that it will be error-free or uninterrupted.",
    ],
  },
  {
    heading: "Governing law",
    paragraphs: [
      "These terms are governed by the laws of India, and any disputes are subject to the jurisdiction of the courts of New Delhi.",
    ],
  },
  {
    heading: "Changes to these terms",
    paragraphs: [
      "We may update these terms from time to time. The version on this page, with its 'last updated' date, is the version in effect.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      testId="terms-page"
      eyebrow="Legal"
      title="Terms of Use"
      updated="July 2026"
      sections={sections}
    />
  );
}
